import { cardeal } from './api';
// import apiForluz from './api';

export class ContribuicaoVoluntariaService {
  getListaContribuicaoVoluntaria = async (matricula) => {
    const response = await cardeal.get('ObterListaContribuicaoVoluntaria', {
      params: { matricula },
    });
    return response.data.ObterListaContribuicaoVoluntariaResult
      .DadosContribuicaoVoluntaria;
  };

  setContribuicaoVoluntaria = async (matricula, valor, autor) => {
    const response = await cardeal.post('RegistrarContribuicaoVoluntaria', {
      matricula,
      valor,
      autor,
    });

    return response.data.ApuraContribuicaoVoluntariaResult;
  };
}
